import React, { useState } from 'react';
import { Table, Nav, NavItem, NavLink } from 'reactstrap';
import AuthRequired from '../components/AuthRequired';
import VacationDoctorSelector from '../components/VacationDoctorSelector';
import DateTimePicker from 'react-datepicker';
import RenderRowVacation from '../components/RenderRowVacation';
import moment from 'moment';
import { displayError } from '../utilities';
import { Query } from 'react-apollo';
import { GET_ALL_DOCS_IDS } from '../queries';

const APPROVAL_STATUS_BY_TAB = {
  pending: 'PENDING',
  approved: 'APPROVED',
  denied: 'REJECTED',
  all: 'ALL'
};

const DEFAULT_RANGE_TABS = ['approved', 'all'];
const DEFAULT_RANGE_DAYS = 30;

const Approval = () => {
  const [state, setstate] = useState('pending');
  const [fromDate, setfromDate] = useState();
  const [toDate, settoDate] = useState();
  const [selectedDoc, setselectedDoc] = useState();
  // Days in the auto-applied default range; null once the user picks dates
  const [autoRangeDays, setautoRangeDays] = useState(null);
  const applyNextDays = days => {
    setfromDate(moment().startOf('day'));
    settoDate(
      moment()
        .add(days, 'days')
        .endOf('day')
    );
    setautoRangeDays(days);
  };
  const clearDates = () => {
    setfromDate(null);
    settoDate(null);
    setautoRangeDays(null);
  };
  const changeState = state => {
    setstate(state);
    if (DEFAULT_RANGE_TABS.includes(state)) {
      if (autoRangeDays || (!fromDate && !toDate)) {
        applyNextDays(DEFAULT_RANGE_DAYS);
      }
    } else if (autoRangeDays) {
      clearDates();
    }
  };

  const onDatesCleared = () => {
    if (DEFAULT_RANGE_TABS.includes(state)) {
      applyNextDays(DEFAULT_RANGE_DAYS);
    } else {
      clearDates();
    }
  };
  return (
    <AuthRequired pageName="approvals">
      <div style={{ margin: '1rem' }}>
        <h1>Vacation Approvals</h1>
        <div style={{ display: 'flex', marginBottom: '1rem' }}>
          <div style={{ flex: 1, marginRight: 20 }}>
            From Date
            <DateTimePicker
              className="form-control"
              placeholderText="From Date"
              selected={fromDate}
              onChange={date => {
                if (!date && !toDate) {
                  onDatesCleared();
                  return;
                }
                setautoRangeDays(null);
                setfromDate(date);
                if (!date || !toDate) {
                  return;
                }
                if (!moment(toDate).isAfter(date)) {
                  settoDate(moment(date).add(1, 'day'));
                } else if (
                  moment(toDate).diff(date, 'days', true) > DEFAULT_RANGE_DAYS
                ) {
                  settoDate(moment(date).add(DEFAULT_RANGE_DAYS, 'days'));
                }
              }}
              dateFormat="DD MMM YYYY"
            />
          </div>
          <div style={{ flex: 1, marginRight: 20 }}>
            To Date
            <DateTimePicker
              className="form-control"
              placeholderText="To Date"
              selected={toDate}
              minDate={fromDate || undefined}
              maxDate={
                fromDate
                  ? moment(fromDate).add(DEFAULT_RANGE_DAYS, 'days')
                  : undefined
              }
              onChange={date => {
                if (!date && !fromDate) {
                  onDatesCleared();
                  return;
                }
                setautoRangeDays(null);
                if (
                  !date ||
                  (fromDate &&
                    moment(fromDate).diff(date, 'millisecond') < 0) ||
                  !toDate
                ) {
                  settoDate(date);
                } else {
                  displayError(`To Date cannot be smaller than From Date`);
                }
              }}
              dateFormat="DD MMM YYYY"
            />
          </div>
          <div style={{ flex: 2 }}>
            Select Doctor
            <VacationDoctorSelector
              onChange={data => setselectedDoc(data ? data.value : null)}
              approvalStatus={APPROVAL_STATUS_BY_TAB[state]}
              vacationFrom={fromDate && toDate ? moment(fromDate) : null}
              vacationTo={fromDate && toDate ? moment(toDate) : null}
              placeholder="Select a Doctor"
            />
          </div>
        </div>
        <Nav>
          <NavItem>
            <NavLink
              active={state === 'pending'}
              onClick={() => changeState('pending')}
              style={{ cursor: 'pointer' }}
            >
              Pending
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              active={state === 'approved'}
              onClick={() => changeState('approved')}
              style={{ cursor: 'pointer' }}
            >
              Approved
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              active={state === 'denied'}
              onClick={() => changeState('denied')}
              style={{ cursor: 'pointer' }}
            >
              Denied
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              active={state === 'all'}
              onClick={() => changeState('all')}
              style={{ cursor: 'pointer' }}
            >
              All
            </NavLink>
          </NavItem>
        </Nav>

        <Table striped bordered>
          <thead>
            <tr>
              <th>Doctor Name</th>
              <th>Last Updated</th>
              <th>Vacation Timing</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <Query query={GET_ALL_DOCS_IDS}>
              {({ data: { getDoctors } = [] }) => (
                <RenderRowVacation
                  doc={selectedDoc ? selectedDoc : null}
                  state={state}
                  fromDate={fromDate}
                  toDate={toDate}
                  getDocs={getDoctors}
                />
              )}
            </Query>
          </tbody>
        </Table>
      </div>
    </AuthRequired>
  );
};

export default Approval;
